"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Button = _interopRequireDefault(require("../Button"));

require("../../assets/css/components/step-accordion.css");

require("../../assets/css/components/banners.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Footer = function Footer(_ref) {
  var handleClick = _ref.handleClick;
  return _react["default"].createElement("div", {
    className: "mod-btn-bot-row"
  }, _react["default"].createElement("span", {
    className: "desktop-view-btn"
  }, _react["default"].createElement("button", {
    className: "text-bottom-line button-default-cs"
  }, "Why we need this?"), _react["default"].createElement(_Button["default"], {
    className: "default-btn odb-default-btn",
    onClick: handleClick
  }, "Proceed")), _react["default"].createElement("span", {
    className: "mob-view-btn"
  }, _react["default"].createElement(_Button["default"], {
    className: "default-btn odb-default-btn full-width",
    onClick: handleClick
  }, "Proceed to Verify")));
};

var _default = Footer;
exports["default"] = _default;